// extracted by mini-css-extract-plugin
module.exports = {"bottom-column-wapper":"fk","bottomColumnWapper":"fk","bottom-column-panel":"fl","bottomColumnPanel":"fl"};